<template>
    <div class="crumb">当前位置： 
        <router-link :to="{path:'/main/index'}">首页</router-link> >
        <router-link :to="{name:item.name}" v-for="(item,index) in crumb" :key="index">{{ item.meta.title || '' }}</router-link>
    </div>
</template>
<script>
export default {
    name: '',
    components: {},
    data() {
        return {
        }
    },
    computed:{
        crumb(){
            return this.$route.matched;
        }
    },
    created(){
        
    },
    methods: {
    },
}
</script>
<style lang='scss' scoped>
</style>